import React, { useEffect } from "react";
import useReveal from "../hooks/useReveal";
import HeroV2 from "../components/HeroV2";
import Services from "../components/Services";
import WhyUs from "../components/WhyUs";
import InstagramFeed from "../components/InstagramFeed";
import { useBooking } from "../context/BookingContext";
import { ArrowRight } from "lucide-react";

export default function HomePage() {
  useReveal();
  const { openBook } = useBooking();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("rebook") === "1") {
      openBook();
      window.history.replaceState({}, "", "/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <HeroV2 />

      <Services />
      <WhyUs />
      <InstagramFeed />
      <section className="py-24 text-center">
        <div className="max-w-2xl mx-auto px-5">
          <p className="section-line text-gold mb-4">Ready When You Are</p>
          <h2 className="font-display text-4xl md:text-5xl font-medium leading-tight">
            Your next <span className="gold-gradient-text italic">glow-up</span> is one tap away.
          </h2>
          <button onClick={openBook} className="mt-8 inline-flex items-center gap-3 text-black font-medium px-8 py-4 rounded-full hover:gap-4 transition-all" style={{ background: "var(--viimii-gold)" }}>
            Book Your Appointment <ArrowRight size={18} />
          </button>
        </div>
      </section>
    </>
  );
}
